// `types` query param for the default-custom-fields endpoint — which placeholder
// families a template editor is allowed to offer. Shared because the same three
// sets are picked from campaign configs, away messages and settings templates.
export const NON_CAMPAIGN_TEMPLATE_VALUE_TYPES = 'contact,company,system';
export const CAMPAIGN_TEMPLATE_VALUE_TYPES = 'contact,company,appointment,system';
export const TEXT_TO_WIN_TEMPLATE_VALUE_TYPES = 'contact,company,campaign,system';
